/*
  Olair header behaviour. Deliberately tiny and dependency-free.
  1. Keeps --announcement-height accurate so the sticky header can let the
     announcement scroll away while the navigation bar stays pinned
     (the design uses `top: -36px`; the bar can wrap on small screens).
  2. Closes the mobile <details> menu on Escape or an outside click.
  Re-runs when the theme editor reloads the section.
*/
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('.section-site-header');
    if (!section || section.dataset.headerReady === 'true') return;
    section.dataset.headerReady = 'true';

    var announcement = section.querySelector('[data-announcement]');

    function setOffset() {
      var height = announcement ? announcement.offsetHeight : 0;
      section.style.setProperty('--announcement-height', height + 'px');
    }

    setOffset();
    if (announcement && 'ResizeObserver' in window) {
      new ResizeObserver(setOffset).observe(announcement);
    } else {
      window.addEventListener('resize', setOffset);
    }

    var drawer = section.querySelector('[data-header-drawer]');
    if (!drawer) return;

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.open) {
        drawer.open = false;
        var summary = drawer.querySelector('summary');
        if (summary) summary.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (drawer.open && !drawer.contains(event.target)) drawer.open = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-site-header') || event.target;
    if (section.classList && section.classList.contains('section-site-header')) {
      delete section.dataset.headerReady;
    }
    init();
  });
})();
